export const ffhEventCategory = 'FFH | Free Form Hub';
export const TrackedFfhEventActions = {
  quantity: 'Quantity',
  filterManufacturingMethodSelect: 'Filter Manufacturing Method | Select',
  filterMaterialSelect: 'Filter Material | Select',
  filterCompareMaterialsOpen: 'Filter Compare Materials | Open',
  filterCompareMaterialsTabSelect: 'Filter Compare Materials | Tab | Select',
  filterCompareMaterialsTabClose: 'Filter Compare Materials | Tab | Close',
  articleSort: 'Article | Sort',
  articleSelect: 'Article | Select',
  articleInfoOpen: 'Article Info | Open',
  articleInfoDownload: 'Article Info | Download',
  articleInfoSelect: 'Article Info | Select',
  articleInfoClose: 'Article Info | Close',
  cartQuantity: 'Cart | Quantity',
  transferToShoppingBasket: 'Transfer To Shopping Basket',
  share: 'Share',
  downloadsSelect: 'Downloads | Select',
  shareLink: 'Share Link',
  openQuantityDiscount: 'Open Quantity Discount',
  uploadModelSuccess: 'Upload Model | Success',
  removeAllFiltersSelect: 'Remove All Filters | Select',
} as const;
